import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=7b7fc576&scoped=true"
import script from "./UserPermissions.vue?vue&type=script&lang=ts"
export * from "./UserPermissions.vue?vue&type=script&lang=ts"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=7b7fc576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7fc576",
  null
  
)

export default component.exports